import { render, staticRenderFns } from "./FulfillmentOptionsFooterShipping.vue?vue&type=template&id=1050759a"
import script from "./FulfillmentOptionsFooterShipping.vue?vue&type=script&lang=ts"
export * from "./FulfillmentOptionsFooterShipping.vue?vue&type=script&lang=ts"
import style0 from "./FulfillmentOptionsFooterShipping.vue?vue&type=style&index=0&id=1050759a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports